module.exports = __webpack_public_path__ + "static/media/manchester.6249630f.png";